import { Point, neighbors } from '../../math/point';
import { Ship } from '../../model/ship';
import { vector, polar, Vector, add, asPoint } from '../../math/vector';
import { normalizeAngle, normalizeAngleSigned, Angle } from '../../math/angle';
import { lt, eq } from '../../math/util';
import { World } from '../../model/world';
import clone from 'immutability-helper'

// ship ai desired state
export interface MoveAction {
  move(world: World, ship: Ship, target: Ship): Point
}

// seek to where target is expected to be
export class InterceptAction implements MoveAction {

  protected desiredVelocity(ship: Ship, target: Ship): Vector {
    const desiredPosition = add(target.position,  polar(target.speed, target.heading))
    const desiredVelocity = vector(ship.position, desiredPosition)
    return desiredVelocity
  }

  move(world: World, ship: Ship, target: Ship): Point {
    const gameGrid = world.grid
    const desiredVelocity = this.desiredVelocity(ship, target)
    const maxVelocity = ship.maxVelocity(desiredVelocity)

    const p0 = add(ship.position, maxVelocity)
    const grid0 = gameGrid.toGrid(p0)
    const p1 = gameGrid.toWorld(grid0)

    const ns = neighbors(grid0).
      map(n => gameGrid.toWorld(n)).
      filter(n => world.enemyShipCanMove(n, ship))

    const ns0 = ns.map((n: Point): [Point, number] => [n, vector(p1, n).length()]).sort((a, b) => a[1] - b[1])

    if (ns0.length > 0) {
      const closestLegalDesiredPoint = ns0[0][0]
      return closestLegalDesiredPoint
    } else {
      console.error("no legal destination")
      return ship.position
      // throw new Error("no legal destination")
    }
  }
}